export default [
  {
    title: 'Home',
    route: 'view-home',
    icon: 'HomeIcon',
  },
]
